var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5008 158.4C41.5008 152.5 46.3267 147.675 52.2258 147.675H127.301V233.475H41.5008V158.4ZM148.751 147.675H234.551V233.475H148.751V147.675ZM256.001 147.675H341.801V233.475H256.001V147.675ZM363.251 147.675H434.572C444.761 147.675 453.877 155.181 455.486 165.369L467.82 241.519C468.892 249.563 469.965 257.606 469.965 265.65H395.426L363.251 233.475V147.675ZM20.0508 147.675V340.725C20.0508 352.522 29.7033 362.175 41.5008 362.175H42.5733C42.0374 358.956 41.5008 355.203 41.5008 351.45C41.5008 321.957 65.6323 297.825 95.1258 297.825C124.62 297.825 148.751 321.957 148.751 351.45C148.751 355.203 148.215 358.956 147.678 362.175H342.873C342.337 358.956 341.801 355.203 341.801 351.45C341.801 321.957 365.932 297.825 395.426 297.825C424.92 297.825 449.051 321.957 449.051 351.45C449.051 355.203 448.515 358.956 447.978 362.175H470.501C482.298 362.175 491.951 352.522 491.951 340.725V272.084C491.951 260.822 490.878 249.025 489.27 237.762L476.936 161.081C473.182 140.703 455.486 125.688 434.572 125.688H41.5008C29.7033 126.225 20.0508 135.875 20.0508 147.675Z",
    fill: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.962 351.452C432.962 372.182 416.156 388.989 395.424 388.989C374.692 388.989 357.887 372.182 357.887 351.452C357.887 330.721 374.692 313.914 395.424 313.914C416.156 313.914 432.962 330.721 432.962 351.452Z",
    fill: "#4F46E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.665 351.452C132.665 372.182 115.859 388.989 95.1273 388.989C74.3956 388.989 57.5898 372.182 57.5898 351.452C57.5898 330.721 74.3956 313.914 95.1273 313.914C115.859 313.914 132.665 330.721 132.665 351.452Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.5292bbf85de3c1b5ee47f845c7a015b3.svg";
export { ForwardRef as ReactComponent };